<template>
  <div
    class="bg-bottom bg-no-repeat bg-cover h-full mx-auto"
    :style="
      'background-image: url(' +
      require('@/assets/images/purchase/bg.jpg') +
      ');'
    "
  >
    <div class="w-full shadow-lg mb-5">
      <img src="@/assets/images/purchase/title-bar.jpg" />
    </div>
    <div class="w-full"><img src="@/assets/images/purchase/content.png" /></div>
    <div class="w-full flex items-center justify-center hidden">
      <button
        class="px-6 py-3 mb-6 bg-blue-900 text-white rounded flex items-center justify-center"
      >
        <svg
          class="w-4 h-4 mr-2 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          />
        </svg>
        <span>跳转1688店铺</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "hello",
  data() {
    return {};
  },
};
</script>
<style scoped></style>
